import { useSelector as _useSelector } from 'react-redux';

export default _useSelector.withTypes();
